import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { addEventListener, jsonp } from 'ThreeTerminal_base/base';
import { InformationFlow, QQShare } from 'ThreeTerminal_mobile';
import { h5PageCount, handleCallNewsApp } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import worldArea from '../../data/worldMap/worldArea';
import SlidesTabs from './slidesTabs';
import Map from './map';
import Sankey from './sankey';
import Line from './line';
import Intro from './intro';
import areaMap from '../../data/wuhan/layout/assets/areaMap.json';
import { getVoteNum, vote } from '../../services/api';
import Haibao from './haibao';
import ShareImg from './shareImg';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: {},
        localData: null, // 近期31省区市本土病例
        docData: null, // 石墨文档数据
        newsData: null, // 新闻数据
        current: null,
        introShow: false,
        introNum: 0,
        isAll: false,
        tabShow: false,
        areaType: 'area',
        currentPath: 'header',
        isExtraAll: false,
        shareNum: '',
        markShow: false,
        hbType: '',
        hbAreaName: '',
    };

    async componentDidMount() {
        const { areaCode } = this.state;
        const {
            content: { base62Id, devicetype },
        } = this.props;

        this.unHandleScroll = addEventListener(window, 'scroll', this.handleScroll);

        // 近期31省区市本土病例
        this.getLocalData();

        // 桑基图数据
        this.getDocData();

        // 新闻数据
        this.getNewsData();

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'article',
                url: encodeURIComponent(location.href),
                rnum: window?.grounds?.getPageInfo?.()?.getRnum?.() || '',
                ref: window?.grounds?.getPageInfo?.()?.getRef?.() || '',
                showtype: window?.grounds?.getPageInfo?.()?.getShowtype?.() || '',
                tag: window?.grounds?.getPageInfo?.()?.getTag?.() || '',
            });
        }

        if (this.isClient()) {
            let code = areaCode;

            /* eslint-disable no-undef */
            if (lastState) {
                Object.keys(areaMap).every(item => {
                    if (lastState.indexOf(areaMap[item]) > -1) {
                        code = item;

                        return false;
                    }

                    return true;
                });
            }
            /* eslint-enable no-undef */

            this.setState({
                areaCode: code,
            });
        } else {
            const shareNum = await getVoteNum(`ucms_${base62Id}`);

            this.setState({
                shareNum: shareNum + 1,
            });
        }

        this.setState({
            data: { ...this.getListData() },
        });
    }

    componentWillUnmount() {
        this.unHandleScroll();
    }

    getLocalData = async () => {
        const data = await jsonp(
            'https://shankapi.ifeng.com/feedflow/coopdoc/wuhanyiqing_data_local_city_detail/info/callback11',
            {
                jsonpCallback: 'callback11',
                cache: false,
            },
        );

        // const provMap = {};

        // data.data.forEach(d => {
        //     if (provMap[d.prov]) {
        //         provMap[d.prov].push(d);
        //     } else {
        //         provMap[d.prov] = [d];
        //     }
        // });

        // data.data = [];

        // const arr = Object.values(provMap).map(p =>
        //     p.sort((a, b) => {
        //         const x = b.confirmAdd - a.confirmAdd;

        //         if (x === 0) {
        //             return b.nowConfirm - a.nowConfirm;
        //         } else {
        //             return x;
        //         }
        //     }),
        // );

        // arr.sort((a, b) => b[0].nowConfirm - a[0].nowConfirm).forEach(a => data.data.push(...a));

        this.setState({
            localData: data,
        });
    };

    getDocData = async () => {
        const data = await jsonp(
            'https://shankapi.ifeng.com/feedflow/coopdoc/doc_0342cd47f01bdc50098ee0f3dfacb58e/info/callback2',
            {
                jsonpCallback: 'callback2',
                cache: false,
            },
        );

        this.setState({
            docData: data,
        });
    };

    getNewsData = async () => {
        const data = await jsonp(
            'https://shankapi.ifeng.com/feedflow/ifengComplaint/dynamic/yiqing_360226/0/20/callback3',
            {
                jsonpCallback: 'callback3',
                cache: false,
            },
        );

        this.setState({
            newsData: data,
        });
    };

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = id => {
        const dom = document.getElementById(`${id}`);
        const offsetTop = dom.offsetTop - 200;

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        let currentPath = 'header';

        if (currentTop - 150 > this.getOffsetTop('sankey')) {
            currentPath = 'sankey';
        }

        if (currentTop - 150 > this.getOffsetTop('chinaMap')) {
            currentPath = 'chinaMap';
        }

        if (currentTop - 150 > this.getOffsetTop('global')) {
            currentPath = 'global';
        }

        // if (currentTop - 150 > this.getOffsetTop('search')) {
        //     currentPath = 'search';
        // }

        if (currentTop - 150 > this.getOffsetTop('news')) {
            currentPath = 'news';
        }

        this.setState({
            currentPath,
            tabShow: currentTop > 100,
        });
    };

    getListData = () => {
        const {
            content: {
                yiqing_v2: { dataList, timestamp },
            },
        } = this.props;

        let result = {};

        try {
            const date = new Date(Number(timestamp));

            const Y = date.getFullYear();
            const M = date.getMonth() + 1;
            const D = date.getDate();
            const h = date.getHours();
            const m = date.getMinutes();

            const time = `截止 ${Y}.${M}.${D} ${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}`;

            const data = dataList;

            if (data) {
                const all = data.filter(item => item.name1 === '全国');
                const gat = data
                    .filter(item => item.name1 === '港澳台')[0]
                    .child.sort((a, b) => {
                        const num1 = Number(a.quezhen);
                        const num2 = Number(b.quezhen);

                        return num2 - num1;
                    });
                const extra = data
                    .filter(item => item.name1 === '国外')[0]
                    .child.sort((a, b) => {
                        const num1 = Number(a.quezhen);
                        const num2 = Number(b.quezhen);

                        return num2 - num1;
                    });

                extra.forEach(item => {
                    if (item.child) {
                        const unknow = item.child.filter(item => item.name2.indexOf('未明确') > -1);

                        item.child = item.child
                            .filter(item => item.name2.indexOf('未明确') === -1)
                            .sort((a, b) => {
                                const num1 = Number(a.quezhen);
                                const num2 = Number(b.quezhen);

                                return num2 - num1;
                            })
                            .concat(unknow);
                    }
                });

                const list = data
                    .filter(
                        item =>
                            item.name1 !== '全国' &&
                            item.name1 !== '港澳台' &&
                            item.name1 !== '国外' &&
                            item.name1.indexOf('输入') === -1,
                    )
                    .sort((a, b) => {
                        const num1 = Number(a.quezhen);
                        const num2 = Number(b.quezhen);

                        return num2 - num1;
                    })
                    .concat(data.filter(item => item.name1.indexOf('输入') > -1));

                const areaData = {};

                list.forEach(item => {
                    areaData[item.name1] = { ...item };

                    if (item.child) {
                        const unknow = item.child.filter(item => item.name2.indexOf('未明确') > -1);

                        item.child = item.child
                            .filter(item => item.name2.indexOf('未明确') === -1)
                            .sort((a, b) => {
                                const num1 = typeof a.quezhen_add === 'number' ? Number(a.quezhen_add) : -Infinity;
                                const num2 = typeof b.quezhen_add === 'number' ? Number(b.quezhen_add) : -Infinity;

                                return num2 - num1;
                            })
                            .concat(unknow);
                    }
                });

                list.sort((a, b) => Number(b.quezhen_add) - Number(a.quezhen_add));

                result = {
                    time,
                    all,
                    gat,
                    extra,
                    list,
                    areaData,
                };

                if (document.querySelector('#ifeng_share_title')) {
                    const guonei_quezhen_add_share = all[0] && all[0].child && all[0].child[0] && all[0].child[0].guonei_quezhen_add && all[0].child[0].guonei_quezhen_add.replace('+', '');
                    const quezhen_wzz_share = all[0] && all[0].child && all[0].child[0] && all[0].child[0].quezhen_wzz && all[0].child[0].quezhen_wzz.replace('+', '');

                    document.querySelector(
                        '#ifeng_share_title',
                    ).innerText = `实时疫情地图：31省份新增本土确诊${guonei_quezhen_add_share}例 无症状${quezhen_wzz_share}例`;
                    // ).innerText = `实时疫情地图：全国确诊${all[0].quezhen}例 死亡${all[0].siwang}例`;
                }
            }
        } catch (error) {
            console.error(error);
        }

        return result;
    };

    // 判断是否是微信
    isWeixin = () => {
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';

        return ua.match(/MicroMessenger/gi);
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleTabChange = currentPath => {
        this.setState({
            currentPath,
        });
    };

    handleDataTabChange = type => {
        this.setState({
            areaType: type,
        });
    };

    handleTimeLineShow = () => {
        const { isAll } = this.state;

        this.setState({
            isAll: !isAll,
        });
    };

    handleIntroShow = (num) => {
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';

        this.setState({
            introShow: true,
            introNum: num,
        });
    };

    goBack = () => {
        window.history.back();
    };

    handleExpand = (index, child) => {
        const { current } = this.state;

        this.setState(
            {
                current: index === current ? null : index,
                hbAreaName: child ? child[0].name1 : null,
            },
            () => {
                const dom = document.querySelectorAll('[data-expand]')[index];

                scrollTo(0, dom.offsetTop - 80);
            },
        );
    };

    getInfoUrl = areaName => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';
        let code = '';

        Object.keys(areaMap).every(item => {
            if (areaName === areaMap[item]) {
                code = item;

                return false;
            }

            return true;
        });

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uGaH6JaA1A?prov=${code}`;
        }

        return url;
    };

    getChinaUrl = () => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7sqjPxP22fg?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7sqjPxP22fg?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7sqjPxP22fg?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7sqjPxP22fg';
        }

        return url;
    };

    handleSearch = () => {
        const url = window.location.href;
        // let searchUrl = 'https://ishare.ifeng.com/c/s/7thiaab7wAK';
        let searchUrl = 'https://ishare.ifeng.com/c/s/838RAj24vRo';

        // if (url.indexOf('srctag') > -1) {
        //     searchUrl = 'https://news.ifeng.com/c/vivo/838RAj24vRo?webkit=1&srctag=exp_national_0_0';
        // }

        window.open(searchUrl);
    };

    getExpand = (index, child, name) => {
        const { current } = this.state;
        const {
            content: { devicetype },
        } = this.props;

        const isClient = this.isClient();
        const url = window.location.href;

        let areaShareShow = true;

        if (devicetype === 'pc' || isClient) {
            areaShareShow = false;
        }

        if (url.indexOf('srctag') > -1) {
            areaShareShow = false;
        }

        if (current === index) {
            return child ? (
                <Fragment>
                    <div className={styles.expandtr_box}>
                        {child.map((item, k) => (
                            <div key={k} className={styles.expandtr}>
                                <span>{item.name2}</span>
                                <span>{item.quezhen_add || 0}</span>
                                <span>{item.quezhen || 0}</span>
                                <span>{item.zhiyu || 0}</span>
                                <span>{item.siwang || 0}</span>
                            </div>
                        ))}
                    </div>

                    <div className={styles.areaShare_box}>
                        <a href={this.getInfoUrl(child[0].name1)}>
                            <span>点击查看详情</span>
                        </a>
                        {areaShareShow && (
                            <div className={styles.areaShare} onClick={() => this.handleShareShow('area')}>
                                <span />
                                <span>{`分享${child[0].name1}数据`}</span>
                            </div>
                        )}
                    </div>
                </Fragment>
            ) : (
                <div className={styles.expandtr}>
                    <p>{name.indexOf('输入') > -1 ? '意大利华侨，该病例直接上报汇总给国家卫健委' : '暂无统计数据'}</p>
                </div>
            );
        }

        return '';
    };

    getWorldCityUrl = code => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uLyp1412jw?code=${code}`;
        }

        return url;
    };

    getWorldUrl = () => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7uLj4F83Cqm?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7uLj4F83Cqm?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7uLj4F83Cqm?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7uLj4F83Cqm';
        }

        return url;
    };

    handleExtraShow = () => {
        const { isExtraAll } = this.state;

        this.setState({
            isExtraAll: !isExtraAll,
        });
    };

    handleShareShow = async hbType => {
        const {
            content: { base62Id },
        } = this.props;

        await vote(`ucms_${base62Id}`);

        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';

        this.setState({
            markShow: true,
            hbType,
        });
    };

    handleMaskHide = e => {
        e.stopPropagation();

        if (e.target.id !== 'mask' && e.target.id !== 'close') {
            return;
        }

        document.querySelector('html').style.overflow = 'auto';
        document.querySelector('body').style.overflow = 'auto';

        this.setState({
            markShow: false,
            introShow: false,
        });
    };

    render() {
        const {
            data,
            data: { time, all, gat, extra, list, areaData },
            introShow,
            introNum,
            tabShow,
            currentPath,
            docData,
            current,
            isExtraAll,
            localData,
            newsData,
            shareNum,
            markShow,
            hbType,
            hbAreaName,
        } = this.state;
        const {
            content,
            content: { leiji, xinzeng },
        } = this.props;

        const tabs = [
            {
                title: '本轮疫情',
                url: '#header',
                searchPath: 'header',
            },
            content.introDisplay === 1
                ? {
                      title: '疫情外溢',
                      url: '#sankey',
                      searchPath: 'sankey',
                  }
                : null,
            {
                title: '全国疫情',
                url: '#chinaMap',
                searchPath: 'chinaMap',
            },
            {
                title: '世界疫情',
                url: '#global',
                searchPath: 'global',
            },
            // {
            //     // title: '同程查询',
            //     title: '出行查询',
            //     url: '#search',
            //     searchPath: 'search',
            // },
            {
                title: '焦点新闻',
                url: '#news',
                searchPath: 'news',
            },
        ];

        const devicetype = content.devicetype;

        const isClient = this.isClient();

        let isCallup = devicetype !== 'pc' && !isClient;

        const url = window.location.href;

        let downloadShow = true;
        let isShowVivoReturnBotton = false;

        if (devicetype === 'pc' || isClient) {
            downloadShow = false;
        }

        if (url.indexOf('srctag') > -1) {
            isCallup = false;
            downloadShow = false;
            isShowVivoReturnBotton = true;
        }

        const guonei_quezhen_add_share = all && all[0] && all[0].child && all[0].child[0] && all[0].child[0].guonei_quezhen_add && all[0].child[0].guonei_quezhen_add.replace('+', '');
        const quezhen_wzz_share = all && all[0] && all[0].child && all[0].child[0] && all[0].child[0].quezhen_wzz && all[0].child[0].quezhen_wzz.replace('+', '');
                    
        const qqShareCofig = {
            title: '“新冠肺炎”全国疫情地图实时动态',
            // img: content.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            img: 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: (guonei_quezhen_add_share && `实时疫情地图：31省份新增本土确诊${guonei_quezhen_add_share}例 无症状${quezhen_wzz_share}例`) || content.introduction || '',
            cb: () => {
                console.log('分享成功');
            },
        };

        // if( window && window.grounds){
        //     window.grounds.openShare({
        //         shareurl: 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk',
        //         title: '“新冠肺炎”全国疫情地图实时动态',
        //         desc: (guonei_quezhen_add_share && `实时疫情地图：31省份新增本土确诊${guonei_quezhen_add_share}例 无症状${quezhen_wzz_share}例`) || content.introduction || '',
        //         thumbnail: 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg'
        //     });
        // }
      
        return (
            <div className={styles.layout}>
                <QQShare content={qqShareCofig} />
                {tabShow && devicetype !== 'pc' && (
                    <SlidesTabs
                        content={tabs}
                        currentPath={currentPath}
                        showShadow
                        handleTabChange={this.handleTabChange}
                    />
                )}
                <a id="header" />
                <div className={styles.banner}>
                    {/* <img
                        src="https://x0.ifengimg.com/ucms/2020_40/A7EEED81029D4107C3BAB2DF6C6839E82E50C339_w1125_h483.png"
                        alt=""
                    /> */}
                    <img
                        src="https://x0.ifengimg.com/ucms/2022_15/99E1E9EBA2B0068119651602B180DB06D0439A44_size157_w1125_h483.png"
                        alt=""
                    />
                    <div className={styles.bottom_bar} />
                </div>
                <div className={styles.data_header}>
                    <div className={styles.tab_box}>
                        <div>全国(含港澳台)</div>
                        {/* <a href={this.getChinaUrl()}>
                            <span>查看疫情信息</span>
                        </a> */}
                        <span className={styles.yi_time}>{time}</span>
                    </div>

                    {all && all.length > 0 && (
                        <Fragment>
                            <div className={styles.yi_con}>
                                {/* 第1行 */}
                                <div className={`${styles.yi_row} ${styles.yi_row1} `}>
                                    <div className={styles.yi_row_box}>
                                       <div className={`${styles.c1} ${styles.yi_row_box_td}`}>{all[0].guonei_quezhen}</div>
                                       <div className={styles.yi_row_box_th}>现存本土确诊</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                       <div className={`${styles.c2} ${styles.yi_row_box_td}`}>{all[0].treating_quezhen}</div>
                                       <div className={styles.yi_row_box_th}>现存确诊</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                       <div className={`${styles.c3} ${styles.yi_row_box_td}`}>{all[0].quezhen}</div>
                                       <div className={styles.yi_row_box_th}>累计确诊</div>
                                    </div>
                                    {/* <div className={styles.yi_row_box}>
                                       <div className={styles.yi_row_box_th}>新增本土确诊<span className={styles.questionIcon} onClick={() => { this.handleIntroShow(0); }} /></div>
                                       <div className={`${styles.yi_row_box_yellow} ${styles.yi_row_box_td}`}>{all[0].child[0].guonei_quezhen_add}</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>新增无症状</div>
                                        <div className={`${styles.yi_row_box_purple} ${styles.yi_row_box_td}`}>{all[0].child[0].quezhen_wzz}</div>
                                    </div> */}
                                    {/* <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>新增境外</div>
                                        <div className={`${styles.yi_row_box_red} ${styles.yi_row_box_td}`}>{all[0].child[0].quezhen_jingwaishuru}</div>
                                    </div> */}
                                    {/* <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>新增本土死亡</div>
                                        <div className={`${styles.yi_row_box_gray} ${styles.yi_row_box_td}`}>{all[0].child[0].guonei_siwang}</div>
                                    </div> */}
                                    {/* <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>新增确诊<span className={styles.questionIcon} onClick={() => { this.handleIntroShow(1); }} /></div>
                                        <div className={`${styles.yi_row_box_pink} ${styles.yi_row_box_td}`}>{all[0].child[0].quezhen}</div>
                                    </div> */}
                                </div>

                                {/* 第2行 */}
                                {/* <div className={`${styles.yi_row} ${styles.yi_row2}`}>
                                    <div className={styles.yi_row_box}>
                                       <div className={styles.yi_row_box_th}>现有本土确诊<span className={styles.questionIcon} onClick={() => { this.handleIntroShow(2); }} /></div>
                                       <div className={`${styles.yi_row_box_yellow} ${styles.yi_row_box_td}`}>{all[0].guonei_quezhen}</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>现有无症状<span className={styles.questionIcon} onClick={() => { this.handleIntroShow(3); }} /></div>
                                        <div className={`${styles.yi_row_box_purple} ${styles.yi_row_box_td}`}>{all[0].quezhen_wzz}</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>现有境外</div>
                                        <div className={`${styles.yi_row_box_red} ${styles.yi_row_box_td}`}>{all[0].treating_jingwai}</div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_tips}>(含港澳台)</div>
                                        <div className={styles.yi_row_box_th}>现有确诊<span className={styles.questionIcon} onClick={() => { this.handleIntroShow(4); }} /></div>
                                        <div className={`${styles.yi_row_box_pink} ${styles.yi_row_box_td}`}>{all[0].treating_quezhen}</div>
                                    </div>

                                </div> */}

                                {/* <div className={styles.yi_line} /> */}

                                {/* 第3行 */}
                                {/* <div className={`${styles.yi_row} ${styles.yi_row3}`}>
                                    <div className={styles.yi_row_box}>
                                       <div className={styles.yi_row_box_th}>累计确诊</div>
                                       <div className={`${styles.yi_row_box_crimson} ${styles.yi_row_box_td}`}>{all[0].quezhen}</div>
                                       <div className={styles.yi_row_box_ft}>昨日<span className={`${styles.yi_row_box_crimson}`}>{all[0].child[0].quezhen}</span></div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>累计境外</div>
                                        <div className={`${styles.yi_row_box_crimson} ${styles.yi_row_box_td}`}>{all[0].quezhen_jingwaishuru}</div>
                                        <div className={styles.yi_row_box_ft}>昨日<span className={`${styles.yi_row_box_crimson}`}>{all[0].child[0].quezhen_jingwaishuru}</span></div>
            
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>累计治愈</div>
                                        <div className={`${styles.yi_row_box_green} ${styles.yi_row_box_td}`}>{all[0].zhiyu}</div>
                                        <div className={styles.yi_row_box_ft}>昨日<span className={`${styles.yi_row_box_green}`}>{all[0].child[0].zhiyu}</span></div>
                                    </div>
                                    <div className={styles.yi_row_box}>
                                        <div className={styles.yi_row_box_th}>累计死亡</div>
                                        <div className={`${styles.yi_row_box_block} ${styles.yi_row_box_td}`}>{all[0].siwang}</div>
                                        <div className={styles.yi_row_box_ft}>昨日<span className={`${styles.yi_row_box_block}`}>{all[0].child[0].siwang}</span></div>
                                    </div>
                                </div> */}
                            </div>
                        </Fragment>
                    )}

                    {/* {all && all.length > 0 && (
                        <Fragment>
                            <div className={styles.sum1}>
                                <div className={styles.num1}>
                                    <span>
                                        <span>昨日</span>
                                        <span>{all[0].child[0].guonei_quezhen_add}</span>
                                    </span>
                                    <span>{all[0].guonei_quezhen}</span>
                                    <span>本土现有确诊</span>
                                </div>
                                <div className={styles.dr} />
                                <div className={styles.num2}>
                                    <span>
                                        <span>昨日</span>
                                        <span>{all[0].child[0].quezhen_xianyou}</span>
                                    </span>
                                    <span>{all[0].quezhen - all[0].zhiyu - all[0].siwang}</span>
                                    <span>现存确诊</span>
                                </div>
                                <div className={styles.dr} />
                                <div className={styles.num3}>
                                    <span>
                                        <span>昨日</span>
                                        <span>{all[0].child[0].quezhen}</span>
                                    </span>
                                    <span>{all[0].quezhen}</span>
                                    <span>累计确诊</span>
                                </div>
                            </div>
                            <div className={styles.sum2}>
                                <div className={styles.num4}>
                                    <span>
                                        <span>昨日</span>
                                        <span>{all[0].child[0].quezhen_wzz}</span>
                                    </span>
                                    <span>{all[0].quezhen_wzz}</span>
                                    <span>无症状感染</span>
                                </div>
                                <div className={styles.dr} />
                                <div className={styles.num5}>
                                    <span>
                                        <span>昨日</span>

                                        <span>{all[0].child[0].quezhen_jingwaishuru}</span>
                                    </span>
                                    <span>{all[0].quezhen_jingwaishuru}</span>
                                    <span>境外输入</span>
                                </div>
                                <div className={styles.dr} />
                                <div className={styles.num6}>
                                    <span>
                                        <span>昨日</span>
                                        <span>{all[0].child[0].siwang}</span>
                                    </span>
                                    <span>{all[0].siwang}</span>
                                    <span>累计死亡</span>
                                </div>
                            </div>
                        </Fragment>
                    )}
                    <div className={styles.time}>
                        <span>
                            <span>{time}</span>
                        </span>
                    </div> */}
                </div>

                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        {/* <span>近期本土病例</span> */}
                        <span>近期31省份病例分布</span>
                    </span>
                    <span className={styles.dataSource}>数据来源：国家卫健委公开数据</span>
                    {/* <span>
                        <a className={styles.link}>
                            {all && all.length > 0 && (
                                <p>
                                    本土现有确诊：{all[0].guonei_quezhen} 昨日{all[0].child[0].guonei_quezhen_add}
                                </p>
                            )}
                        </a>
                    </span> */}
                </div>
                <div id="list" className={`${styles.data_box} ${styles.local}`}>
                    <div className={styles.thead}>
                        <span>城市(区)</span>
                        <span>省市区</span>
                        {/* <span>新增确诊</span>
                        <span>新增无症状</span> */}
                        <span>现存确诊</span>
                        <span>累计确诊</span>
                    </div>
                    <div className={styles.tbody}>
                        {localData &&
                            localData.data.map((item, index) => (
                                /* eslint-disable no-confusing-arrow */
                                <Fragment key={index}>
                                    <div className={styles.tr}>
                                        <div className={styles.tr_list}>
                                            <span>{item.city}</span>
                                            <span>{item.prov}</span>
                                            {/* <span>{item.confirmAdd}</span>
                                            <span>{item.wzzAdd}</span> */}
                                            <span className={item.zhiyu ? styles.zhiyu : ''}>
                                                {item.nowConfirm || 0}
                                            </span>
                                            <span>{item.confirm}</span>
                                        </div>
                                    </div>
                                </Fragment>
                                /* eslint-abled no-confusing-arrow */
                            ))}
                    </div>
                </div>
                <div className={styles.danger}>
                    <a href="https://ishare.ifeng.com/c/s/v004U-_vdkyJDS5PTpD-_Y-_oyVHSC8ZIW07NS1vhhxWNS8w1s__?from=ucms_web">
                        点击查看出行政策
                    </a>
                </div>

                <a id="sankey" />
                {content.introDisplay === 1 && (
                    <>
                        <div className={styles.title_box3}>
                            <span>
                                <img
                                    src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                                    alt=""
                                />
                                <span>疫情外溢传播链</span>
                            </span>
                        </div>

                        {docData && <Sankey docData={docData} />}
                    </>
                )}

                {/* <a id="chinaMap" />
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>确诊地图</span>
                    </span>
                </div> */}
                {/* {list && gat && (
                    <Map
                        mapType="china"
                        data={data}
                        // TODO: 移除默认区域 areaName={areaName}
                        areaName="江苏"
                        nanhai="https://x0.ifengimg.com/ucms/2020_11/9B152FA6043219BC0C5B708B993E59AEC2AB7C8F_w1450_h1970.png"
                        devicetype={devicetype}
                    />
                )} */}
                {/* 本轮国内疫情趋势*/}
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>国内疫情趋势</span>
                    </span>
                </div>
                <Line leijiData={[...leiji.dataList]} xinzengData={[...xinzeng.dataList]} />

                {/* <div className={styles.title_box}>
                    <span />
                    <span>大陆地区病例</span>
                </div>
                <div className={styles.title_tip}><span>7:00—10:00为数据更新高峰，数据如有滞后请谅解。</span></div>
                <div id="list" className={styles.data_box}>
                    <div className={styles.thead}>
                        <span>省市</span>
                        <span>昨日新增</span>
                        <span>累计确诊</span>
                        <span>治愈</span>
                        <span>死亡</span>
                        <span>疫情</span>
                    </div>
                    <div className={styles.tbody}>
                        {list &&
                            list.map((item, index) => (
                                <Fragment key={index}>
                                    <div
                                        data-expand
                                        className={`${styles.tr} ${current === index ? styles.current_tr : ''}`}
                                        onClick={() => this.handleExpand(index, item.child)}>
                                        <div className={styles.expand}>
                                            <img
                                                className={current === index ? styles.unfold : styles.fold}
                                                src="https://x0.ifengimg.com/ucms/2020_07/6DB12E34118DB38FBFFB02C2D4BD78BA8F5EF0CA_w30_h21.png"
                                            />
                                        </div>
                                        <div className={styles.tr_list}>
                                            <span>{item.name1}</span>
                                            <span>{item.quezhen_add || 0}</span>
                                            <span>{item.quezhen || 0}</span>
                                            <span className={item.zhiyu ? styles.zhiyu : ''}>{item.zhiyu || 0}</span>
                                            <span className={item.siwang ? styles.siwang : ''}>{item.siwang || 0}</span>
                                            {item.name1 === '西藏' || item.name1.indexOf('输入') > -1 ? (
                                                ''
                                            ) : (
                                                <a href={this.getInfoUrl(item.name1)} />
                                            )}
                                        </div>
                                    </div>
                                    {this.getExpand(index, item.child, item.name1)}
                                </Fragment>
                            ))}
                    </div>
                </div> */}
                <div className={styles.title_box}>
                    <span />
                    <span>港澳台地区病例</span>
                </div>
                <div id="gat" className={styles.data_box}>
                    <div className={`${styles.thead} ${styles.thead_gat}`}>
                        <span>地区</span>
                        <span>新增感染</span>
                        <span className={styles.blackColor}>新增死亡</span>
                        <span>累计确诊</span>
                    </div>
                    <div className={styles.tbody}>
                        {gat &&
                            gat.map((item, index) => {
                                return (
                                    item.name2 === '香港' && (
                                        <div key={index} className={styles.tr}>
                                            <div className={`${styles.tr_list} ${styles.tr_list_gat}`}>
                                                <span>{item.name2}</span>
                                                <span>{item.quezhen_add || 0}</span>
                                                <span>{item.siwang || 0}</span>
                                                <span>{item.quezhen || 0}</span>
                                            </div>
                                        </div>
                                    )
                                );
                            })}
                        {gat &&
                            gat.map((item, index) => {
                                return (
                                    item.name2 === '澳门' && (
                                        <div key={index} className={styles.tr}>
                                            <div className={`${styles.tr_list} ${styles.tr_list_gat}`}>
                                                <span>{item.name2}</span>
                                                <span>{item.quezhen_add || 0}</span>
                                                <span>{item.siwang || 0}</span>
                                                <span>{item.quezhen || 0}</span>
                                            </div>
                                        </div>
                                    )
                                );
                            })}
                        {gat &&
                            gat.map((item, index) => {
                                return (
                                    item.name2 === '台湾' && (
                                        <div key={index} className={styles.tr}>
                                            <div className={`${styles.tr_list} ${styles.tr_list_gat}`}>
                                                <span>{item.name2}</span>
                                                <span>{item.quezhen_add || 0}</span>
                                                <span>{item.siwang || 0}</span>
                                                <span>{item.quezhen || 0}</span>
                                            </div>
                                        </div>
                                    )
                                );
                            })}
                    </div>
                    <div className={styles.data_info}>
                        {/* {time} */}
                        {/* <br /> */}
                        {/* 数据来源：香港经济日报 澳门卫生局 台湾疾控部门{' '} */}
                        数据来源：香港卫生署 澳门卫生局 台湾疾控部门{' '}
                    </div>
                </div>

                <a id="global" />
                <div className={styles.world_box}>
                    <div>
                        <span>国外病例</span>
                    </div>
                    <a href={this.getWorldUrl()}>
                        <span>点击查看全球疫情</span>
                    </a>
                </div>
                {/* {extra && <Map mapType="world" data={data} />} */}
                <div id="extra" className={styles.data_box}>
                    <div className={`${styles.thead} ${styles.thead_extra} ${styles.tr_list_extra}`}>
                        <span>国家</span>
                        {/* <span>新增病例</span> */}
                        <span>累计确诊</span>
                        {/* <span>治愈</span> */}
                        <span>死亡</span>
                        {/* <span>疫情</span> */}
                    </div>
                    <div className={styles.tbody}>
                        {extra &&
                            extra.slice(0, isExtraAll ? extra.length : 10).map((item, index) => (
                                /* eslint-disable no-nested-ternary */
                                <div
                                    key={index}
                                    className={`${styles.tr} ${
                                        index === (isExtraAll ? extra.length - 1 : 9) ? styles.last_tr : ''
                                    }`}>
                                    <div className={styles.expand_extra} />
                                    <div className={`${styles.tr_list} ${styles.tr_list_extra}`}>
                                        <span>{item.name2}</span>
                                        {/* <span>{item.quezhen_add || 0}</span> */}
                                        <span>{item.quezhen || 0}</span>
                                        {/* <span>{item.zhiyu || 0}</span> */}
                                        <span>{item.siwang || 0}</span>
                                        {/* {Object.keys(worldArea).indexOf(item.name2) > -1 &&
                                            worldArea[item.name2].code && (
                                                <a href={this.getWorldCityUrl(worldArea[item.name2].code)} />
                                            )} */}
                                    </div>
                                </div>
                                /* eslint-able no-nested-ternary */
                            ))}
                        <div className={styles.extraMore} onClick={this.handleExtraShow}>
                            <span>{isExtraAll ? '点击收起' : '查看更多'}</span>
                            <img
                                className={isExtraAll ? styles.all : styles.noAll}
                                src="https://x0.ifengimg.com/ucms/2020_06/B47A435EB8F1B6223FEFFEBFFB85C53E9982C0C6_w24_h24.png"
                            />
                        </div>
                    </div>
                </div>

                {/* <a id="search" />
                <div className={styles.title_box2}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>疫情小区、同程查询</span>
            
                    </span>
                </div>
                <div className={styles.search_box}>
                    <p>秒查！新冠肺炎确诊患者的小区离你有多远？</p>
                    <p>快速把握周边疫情，同时支持确诊患者同行程查询。</p>
                    <span onClick={this.handleSearch}>点击查询</span>
                </div> */}

                <a id="news" />
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>焦点新闻</span>
                    </span>
                </div>

                <div className={isCallup ? styles.info_box0 : styles.info_box1}>
                    {newsData && <InformationFlow content={newsData.data} isDisplayLoadingMore={false} />}
                </div>
                {/* {downloadShow && (
                    <div className={styles.download}>
                        <a href={this.getChinaUrl()} className={styles.download_enter}>
                            <span>进入专题</span>
                        </a>
                        <div onClick={() => this.handleShareShow('all')} className={styles.share}>
                            <a className={styles.headerBox}>
                                <span className={styles.txt1}>分享实时疫情</span>
                                <span className={styles.txt2}>
                                    我是第<span>{shareNum}</span>个抗疫接力者
                                </span>
                            </a>
                        </div>
                    </div>
                )} */}
                {isShowVivoReturnBotton && (
                    <div className={styles.return_icon} onClick={this.goBack}>
                        返回
                    </div>
                )}
                {/* {markShow && (
                    <div
                        id="mask"
                        className={styles.mask}
                        style={{ fontSize: document.body.style.fontSize }}
                        onClick={this.handleMaskHide}>
                        {all && all.length > 0 && list && gat && areaData && (
                            <Haibao hbType={hbType} handleMaskHide={this.handleMaskHide} />
                        )}
                    </div>
                )} */}
                {introShow && (
                    <div
                        id="mask"
                        className={styles.mask}
                        style={{ fontSize: document.body.style.fontSize }}
                        onClick={this.handleMaskHide}>
                        <Intro introNum={introNum} handleMaskHide={this.handleMaskHide} />
                    </div>
                )}
                {/* {all && all.length > 0 && list && gat && areaData && (
                    <ShareImg
                        hbType="all"
                        data={all[0]}
                        time={time}
                        shareNum={shareNum}
                        mapData={[...list, ...gat]}
                        nanhai="https://x0.ifengimg.com/ucms/2020_11/9B152FA6043219BC0C5B708B993E59AEC2AB7C8F_w1450_h1970.png"
                        handleMaskHide={this.handleMaskHide}
                    />
                )}
                {all && all.length > 0 && list && gat && areaData && (
                    <ShareImg
                        hbType="area"
                        areaName={hbAreaName}
                        data={all[0]}
                        time={time}
                        shareNum={shareNum}
                        mapData={[...list, ...gat]}
                        nanhai="https://x0.ifengimg.com/ucms/2020_11/9B152FA6043219BC0C5B708B993E59AEC2AB7C8F_w1450_h1970.png"
                        handleMaskHide={this.handleMaskHide}
                    />
                )} */}
            </div>
        );
    }
}

export default errorBoundary(Layout);
